<ion-content>
  <ion-row>
    <ion-col size="12">
      <ion-row>
        <ion-col size="8">
          <h2>Notifications</h2>
        </ion-col>
        <ion-col size="4" class="ion-text-right">
          <ion-button (click)="close()" class="default" size="small"
            ><ion-icon name="close-circle-outline"></ion-icon
          ></ion-button>
        </ion-col>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col size="12" class="ion-text-right">
      <a
        (click)="markAllAsRead()"
        class="link-btn"
        style="
          color: var(--ion-color-primary);
          font-weight: bold;
          font-size: 0.825rem;
          margin-right: 1rem;
        "
        >Mark all as read
      </a>
    </ion-col>
    <ion-col size="12">
      <ngx-datatable
        #dataTable
        [rows]="notifications"
        [messages]="{
          emptyMessage: 'noDataFound' | translate,
          totalMessage: 'totalMessage' | translate
        }"
        [rowHeight]="'auto'"
        [headerHeight]="50"
        [externalPaging]="true"
        [columnMode]="'force'"
        [offset]="pageIndex"
        [limit]="pageSize"
        [headerHeight]="0"
        [footerHeight]="50"
        [scrollbarH]="true"
        [count]="total"
        [class]="'material no-header table-no-row-border'"
        (page)="handlePageChange($event)"
      >
        <ngx-datatable-column>
          <ng-template
            let-row="row"
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
          >
            <ion-row
              (click)="handleClickNotification(row)"
              [style]="
                !row.isRead
                  ? 'background-color: var(--ion-color-bord); border: 1px solid #c8cdd9;'
                  : 'border: 1px solid var(--ion-color-bord);'
              "
              style="font-size: 0.825rem; padding: 10px 4px; cursor: pointer"
            >
              <ion-col size="12">
                <ion-text
                  style="color: var(--ion-color-primary); font-weight: bold"
                >
                  {{ row.type | translate }}
                  <span *ngIf="row.type == 'Emegency' && row.isBlockClick">
                    (Resolved)
                  </span>
                </ion-text>
                <!-- <span style="display: block">
                    {{ getRowTitle(row.title) }}
                  </span> -->
              </ion-col>
              <ion-col size="12">
                <ion-text
                  [innerHTML]="renderMessage(row) | safeHtml"
                ></ion-text>
              </ion-col>
              <ion-col size="12" style="text-align: end">
                <div
                  style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <ion-badge
                    color="tertiary"
                    style="cursor: pointer; border-radius: 2px; color: white"
                    (click)="doNotification($event, row, rowIndex)"
                  >
                    <div style="display: flex; align-items: center">
                      {{
                        (!row.isRead ? "markRead" : "markUnread") | translate
                      }}
                      <ion-spinner
                        *ngIf="isLoadingRead[rowIndex]"
                        style="
                          margin-left: 4px;
                          font-size: 12px;
                          width: 12px;
                          height: 12px;
                        "
                      >
                      </ion-spinner>
                    </div>
                  </ion-badge>
                  <ion-text style="font-size: 12px">
                    {{ row.timeCreated + "Z" | date : "yyyy-MMM-dd HH:mm" }}
                  </ion-text>
                </div>
              </ion-col>
            </ion-row>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </ion-col>
  </ion-row>
</ion-content>
